<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :showFields="showFields"
      orderBy="sequence"
      orderWay="asc"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/locale";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "sequence",
      "code",
      "name",
      "backup_locale",
      "updated_at",
      "updated_admin",
      "is_active",
    ],
  }),
  computed: {},
};
</script>